import LegalShell from "./LegalShell";
import { useLang } from "../../i18n";

const Block = ({ title, children, testid }) => (
  <section className="border-b border-[#9B7AE8]/12 py-8 first:pt-0 last:border-0" data-testid={testid}>
    {title && <h2 className="font-display mb-4 text-lg font-bold text-[#221A3D]">{title}</h2>}
    <div className="space-y-1.5 text-base leading-relaxed text-[#5F5780]">{children}</div>
  </section>
);

export default function CompanyInfo() {
  const { t } = useLang();
  const c = t.company;
  return (
    <LegalShell title={c.title} testid="company-info-page">
      <Block testid="company-block-general">
        <p>{c.intro}</p>
        <p className="font-semibold text-[#221A3D]">Lussho GmbH</p>
        <p>{c.address}</p>
        <p>
          {c.emailLabel}{" "}
          <a href="mailto:info@shakeandshake.com" className="text-[#9B7AE8] underline underline-offset-4">
            info@shakeandshake.com
          </a>
        </p>
      </Block>

      <Block title={c.boardTitle} testid="company-block-board">
        {c.board.map((name) => (
          <p key={name}>{name}</p>
        ))}
      </Block>

      <Block title={c.bankTitle} testid="company-block-bank">
        {c.bank.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </Block>

      <Block title={c.regTitle} testid="company-block-registry">
        {c.reg.map((line) => (
          <p key={line}>{line}</p>
        ))}
      </Block>

      <Block title={c.legalTitle} testid="company-block-legal">
        <p>{c.legal1}</p>
        <p>
          <a
            href={c.odr}
            target="_blank"
            rel="noopener noreferrer"
            className="break-all text-[#9B7AE8] underline underline-offset-4"
          >
            {c.odr}
          </a>
        </p>
        <p>{c.legal2}</p>
        <p>{c.legal3}</p>
      </Block>
    </LegalShell>
  );
}
